import React from "react";
import { trackCheckout } from "./metaPixel";
const CHECKOUT_URL = "https://aromaticos.impultienda.ar/checkout/artesanal";
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
  glow?: boolean;
}
export function CtaButton({
  children,
  className = "",
  glow = false
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} onClick={() => trackCheckout()} className={`group inline-flex w-full items-center justify-center gap-2 rounded-full bg-[var(--mauve)] px-6 py-4 text-center text-base font-semibold uppercase tracking-wide text-white shadow-lg transition-all duration-300 hover:bg-[var(--mauve-deep)] hover:-translate-y-0.5 active:translate-y-0 sm:text-lg ${glow ? "animate-pulse-glow" : ""} ${className}`} data-id="element-215" data-mp="cjzpi1q65n87">
      {children}
    </a>;
}